import { Children, useCallback, useEffect, useState } from "react";

import { Link } from "react-router-dom";
import NewsAvatar from "../../components/general/misc/NewsAvatar";
import SectionTitle from "../../components/general/misc/SectionTitle";
import { getTopNews } from "../../services/homeRequestServices";
import styled from "styled-components";
import variables from "../../assets/js/variables";

const { colors, gridBreakpoints } = variables;

const News = () => {
  const [newsData, changeNewsData] = useState([]);

  const getNewsData = useCallback(() => {
    return getTopNews().then(({ results }) => changeNewsData(results));
  }, []);

  useEffect(() => {
    getNewsData();
  }, [getNewsData]);

  return (
    <NewsContainer className="d-flex flex-column align-items-center justify-content-center">
      <TitleRow className="d-flex w-100 mb-5">
        <div className="d-flex">
          <SectionTitle iconName="icon-add-solid" text="تازه‌های هوش‌آیند" />
        </div>
        <Link
          to="/news"
          className="btn btn-sm px-4 bg-green text-black border-radius-10"
        >
          مشاهده همه تازه‌ها
        </Link>
      </TitleRow>
      <NewsList className="d-grid">
        {Children.toArray(
          newsData.map((item) => (
            <NewsItem className="d-flex flex-row">
              <NewsAvatar
                className="ms-4"
                size={95}
                photo={item?.photo}
                alt={item?.title}
              />
              <NewsContent className="d-flex flex-column">
                <h3 className="text-16 text-white">{item.title}</h3>
                <a href={item.url} className="text-green text-14">
                  بیشتر بدانید
                </a>
              </NewsContent>
            </NewsItem>
          ))
        )}
      </NewsList>
    </NewsContainer>
  );
};

export default News;

const NewsContainer = styled.div`
  margin-top: 2rem;
  background-color: ${colors.darkBlue};

  @media (max-width: ${gridBreakpoints.md}px) {
    padding: 1rem;
  }

  @media (min-width: ${gridBreakpoints.md + 1}px) {
    padding: 3rem 6rem;
  }
`;

const TitleRow = styled.div`
  align-items: center;
  justify-content: space-between;
`;

const NewsList = styled.div`
  gap: 1rem;

  @media (max-width: ${gridBreakpoints.md}px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: ${gridBreakpoints.md +
    1}px) and (max-width: ${gridBreakpoints.xl}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${gridBreakpoints.xl + 1}px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const NewsItem = styled.div`
  line-height: 24px !important;
  max-height: 95px;

  h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    line-height: 1.8;
  }
`;

const NewsContent = styled.div`
  height: inherit;

  a {
    width: fit-content;
    border-bottom: solid 1px transparent;

    &:hover {
      border-bottom-color: inherit;
    }
  }
`;
